export default "__VITE_ASSET__3cb751b1__"